var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('formio-overview-component',{attrs:{"formExpansionDefinition":_vm.formDefinition,"buttonLoading":_vm.buttonLoading},on:{"cancel":_vm.onCancel}})}
var staticRenderFns = []

export { render, staticRenderFns }